import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
export function render(_ctx, _cache) {
    const _component_router_view = _resolveComponent("router-view");
    return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx((param)=>{
            let { Component, route } = param;
            return [
                _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                }, {
                    default: _withCtx(()=>[
                            (_openBlock(), _createElementBlock("div", {
                                key: route.path,
                                class: "mx-auto"
                            }, [
                                !route.meta.link ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                                    key: 0
                                })) : _createCommentVNode("", true)
                            ]))
                        ]),
                    _: 2
                }, 1024)
            ];
        }),
        _: 1
    });
}
